export default {
  BILLING_LIST_CLAIM: 'claim',
  BILLING_LIST_PAYROLL: 'payroll',
  BILLING_LIST_EXPORT: 'export'
}
